import { defineStore } from 'pinia';
import { FormItemFilter, FormItemFilterRecord } from '@/services/api/resources/analytics-builder/model';

interface State {
  formItems: Map<string|number, FormItemFilterRecord>;
}

export const useFormItemsStore = defineStore('formItem', {
  state: (): State => ({
    formItems: new Map<string|number, FormItemFilterRecord>(),
  }),
  actions: {
    addAll(items: FormItemFilter) {
      items.data.forEach(item => this.formItems.set(item.id, item));
    },
    add(item: FormItemFilterRecord) {
      this.formItems.set(item.id, item);
    },
    find(id: string|number) {
      return this.formItems.get(id);
    },
  },
});
